import { useFiltersQuery } from 'apollo/filters';
import { ApiFilter } from '../types';
import { getMergedFilters } from '../helpers/getMergedFilters';

const useApiFilters = (): {
    apiFilters: ApiFilter[];
} => {
    const { data: filtersData, loading } = useFiltersQuery();

    const mergedFilters = getMergedFilters(loading, filtersData);

    return {
        apiFilters: mergedFilters,
    };
};

export default useApiFilters;
